"use strict";
angular
	.module( "ATMGurus" )
	.factory("ContentService", ContentService );

ContentService.$inject = ["ApiQuery", "$q", "$rootScope"];

function ContentService( ApiQuery, $q, $rootScope ) {
	let cachedContent = []
	return {
		load: function(page) {
			let defer = $q.defer()
			page = typeof page === undefined ? "/" : "/" + page;
			if (page === '/training/guru-u-class-schedule' || cachedContent[page] === undefined) {
				ApiQuery(`v1/content${page}`, "", "GET" )
					.then(response => {
						response.data.data.nav = response.data.nav
						$rootScope.$emit('meta.refreshed', response.data.meta)
						cachedContent[page] = response.data.data
						cachedContent[page].meta = response.data.meta
						cachedContent[page].template = response.data.template
						defer.resolve(cachedContent[page]);
						// defer.resolve(response.data.data);
					}, function( reason ) {
						defer.reject( reason )
					})
			} else {
				defer.resolve( cachedContent[ page ] );
				// refresh title/meta/desc
				$rootScope.$emit('meta.refreshed', { 
					page_title: cachedContent[page].meta.page_title, 
					description: cachedContent[page].meta.description 
				});
			}
			return defer.promise;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/services/ContentService.js